import { IDynamicItemValue } from '@epicuro-next/models/platform/dynamic-elements/dynamic-elements';
import { ProductsOnTheWayPayloadPropertiesType } from '../../../../tenants/common/products-on-the-way/products-on-the-way-helpers';

export function createApiRequestPayloadPropertiesProvider(providers: {
  fromDate: IDynamicItemValue;
  toDate: IDynamicItemValue;
  shipTo?: IDynamicItemValue;
  filterMissingImages: IDynamicItemValue;
  brandId: IDynamicItemValue;
}): IDynamicItemValue {
  return {
    values: [
      providers.brandId,
      providers.fromDate,
      providers.toDate,
      providers.shipTo,
      providers.filterMissingImages,
    ],
    transform: function ([
      brandId,
      fromDate,
      toDate,
      shipTo,
      filterMissingImages,
    ]: [string, string, string, string | undefined | null, boolean]) {
      const payloadProperties: ProductsOnTheWayPayloadPropertiesType = {
        brandId,
        fromDate,
        toDate,
        filterMissingImages,
      };

      if (shipTo?.length) {
        payloadProperties.addressId = shipTo[0];
      }

      return payloadProperties;
    }.toString(),
  };
}
